import React from "react";
import Button, { ButtonTypeMap } from "@material-ui/core/Button";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ExtendButtonBase } from "@material-ui/core/ButtonBase";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    padding: "1rem 1.5rem 0.5rem",
  },
  message: {
    padding: "0 1.5rem",
  },
  text: {
    fontSize: "0.875rem",
  },
  actions: {
    justifyContent: "space-between",
    padding: "1rem 1.5rem",
  },
}));

type Props = DialogProps & {
  title: React.ReactNode;
  message: React.ReactNode;
  confirmButtonText?: React.ReactNode;
  confirmButtonProps?: ExtendButtonBase<ButtonTypeMap>;
  cancelButtonProps?: ExtendButtonBase<ButtonTypeMap>;
  cancelButtonText?: React.ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
};

const ConfirmModal: React.FC<Props> = ({
  title,
  message,
  confirmButtonText,
  confirmButtonProps,
  cancelButtonText,
  cancelButtonProps,
  onConfirm,
  onCancel,
  open,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Dialog open={open} {...props} data-testid="confirmation-modal-test-id">
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.message}>
        <DialogContentText className={classes.text}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={onConfirm} color="primary" variant={"contained"} {...confirmButtonProps}>
          {confirmButtonText}
        </Button>
        {cancelButtonText && (
          <Button onClick={onCancel} color="primary" {...cancelButtonProps}>
            {cancelButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
